import React, { Component } from 'react';
import { connect } from 'dva';
import { Layout } from 'antd';
import { Switch } from 'dva/router';
import { NavBar, LeftSideBar, TopBar } from '../basic';
import pathToRegexp from 'path-to-regexp';
import { enquireIsMobile } from '@/utils/enquireScreen';
import TabsLayout from './TabsLayout';
// import { WizWatermarkCmp } from '@/containers/common';
import './styles/basic.less';
import cx from 'classnames';
const { Content, Header } = Layout;
import { utils_tool, framework_tool } from '../../tool'
let { $$, Storage } = utils_tool
let { WizContainer } = framework_tool
/**
 * 基本部局
 * 可设置多种皮肤 theme: [light, grey, primary, info, warning, danger, alert, system, success, dark]
 * 可设置多种布局 [header(固定头), sidebar(固定边栏), breadcrumb(固定面包蟹), tabLayout(标签布局)]
 * @author weiq
 */
@connect(({ systemMenu }) => ({ systemMenu }))
export default class BasicLayout extends WizContainer {
  constructor(props) {
    super(props);
    const user = $$.setStore('user', []);
    const theme = $$.setStore('theme', {
      layout: [
        'fixedHeader',//      固定头部
        'fixedSidebar',//      固定边栏
        'fixedBreadcrumbs',//      固定面包屑
        'hidedBreadcrumbs',//      隐藏面包屑
        'tabLayout',//      标签模式
      ],
      leftSide: 'light', // 左边
      navbar: 'light' // 顶部
    });
    // if (!theme.layout) {
    //   theme.layout = [
    //     'fixedHeader',
    //     'fixedSidebar',
    //     'fixedBreadcrumbs',
    //     'hidedBreadcrumbs',
    //     'tabLayout',
    //   ];
    // }

    this.state = {
      collapsedLeftSide: false, // 左边栏开关控制
      leftCollapsedWidth: 600, // 左边栏宽度
      expandTopBar: false, // 头部多功能区开合
      showSidebarHeader: false, // 左边栏头部开关
      collapsedRightSide: false, // 右边栏开关
      // theme, // 皮肤设置
      user,
      currentMenu: {},
      isMobile: false
    };
    this.user = Storage.getStorage('user')
  }

  _componentWillMount() {
    if (this.user && this.user['personId']) {
      this.getMenu(this.user['personId'])
    }
  }


  getMenu = (personId) => {
    if (personId) {
      this.personId = personId
      this.props.dispatch({
        type: 'systemMenu/getMenu',
        payload: { personId }
      });
    }
  }

  componentDidMount() {
    this.unregisterEnquire = enquireIsMobile(ismobile => {
      const { isMobile } = this.state;
      if (isMobile !== ismobile) {
        this.setState({
          isMobile: ismobile
        });
      }
    });
  }


  componentWillReceiveProps(nextProps) {
    let _user = Storage.getStorage('user')
    if (_user && this.personId && _user['personId'] !== this.personId) {
      this.getMenu(_user['personId'])
    }
    if (
      nextProps.location.pathname !== this.props.location.pathname ||
      nextProps.systemMenu.flatMenu !== this.props.systemMenu.flatMenu
    ) {
      this.setState({
        currentMenu: this.getCurrentMenu(nextProps) || {}
      });
    }
  }

  componentWillUnmount() {
    // 清理监听
    this.unregisterEnquire();
  }

  getCurrentMenu(props) {
    const {
      location: { pathname },
      systemMenu
    } = props || this.props;
    const menu = this.getMeunMatchKeys(systemMenu.flatMenu, pathname)[0];
    return menu;
  }

  getMeunMatchKeys = (flatMenu, path) => {
    return flatMenu.filter(item => {
      return pathToRegexp(item.path).test(path);
    });
  };

  /**
   * 顶部左侧菜单图标收缩控制
   */
  onCollapseLeftSide = _ => {
    const collapsedLeftSide =
      this.state.leftCollapsedWidth === 0
        ? true
        : !this.state.collapsedLeftSide;
    const collapsedRightSide =
      this.state.collapsedRightSide || !collapsedLeftSide;

    this.setState({
      collapsedLeftSide,
      collapsedRightSide,
      leftCollapsedWidth: 60
    });
  };

  /**
   * 完全关闭左边栏，即宽为0
   */
  onCollapseLeftSideAll = _ => {
    this.setState({
      collapsedLeftSide: true,
      leftCollapsedWidth: 0
    });
  };

  /**
   * 展开面包屑所在条中的多功能区
   */
  onExpandTopBar = _ => {
    this.setState({
      expandTopBar: true
    });
  };

  /**
   * 与上面相反
   */
  onCollapseTopBar = _ => {
    this.setState({
      expandTopBar: false
    });
  };

  /**
   * 切换左边栏中头部的开合
   */
  toggleSidebarHeader = _ => {
    this.setState({
      showSidebarHeader: !this.state.showSidebarHeader
    });
  };

  /**
   * 切换右边栏
   */
  toggleRightSide = _ => {
    const { collapsedLeftSide, collapsedRightSide } = this.state;
    this.setState({
      collapsedLeftSide: collapsedRightSide ? true : collapsedLeftSide,
      collapsedRightSide: !collapsedRightSide
    });
  };

  // onChangeTheme = theme => {
  //   // Storage.setStorage('theme', theme);
  //   $$.setStore('theme', theme);
  //   this.setState({
  //     theme
  //   });
  // };

  /**
   * 初始化路由
   */
  _initMenu = () => {
    this.setState({
      currentMenu: {},
      location: { pathname: "/home", record: {}, search: "", hash: "" }
    })
  }

  render() {
    const {
      collapsedLeftSide,
      leftCollapsedWidth,
      expandTopBar,
      showSidebarHeader,
      collapsedRightSide,
      // theme,
      user,
      currentMenu,
      isMobile
    } = this.state;
    const { routerData, location, systemMenu } = this.props;
    const { menu, flatMenu } = systemMenu;
    const { childRoutes } = routerData;
    const classnames = cx('basic-layout', 'full-layout'
      // , {
      //   fixed: theme.layout && theme.layout.indexOf('fixedSidebar') !== -1,
      //   'fixed-header':
      //     theme.layout && theme.layout.indexOf('fixedHeader') !== -1,
      //   'fixed-breadcrumbs':
      //     theme.layout && theme.layout.indexOf('fixedBreadcrumbs') !== -1,
      //   'hided-breadcrumbs':
      //     theme.layout && theme.layout.indexOf('hidedBreadcrumbs') !== -1
      // }
    );
    const theme = $$.getStore('theme')
    return (
      <Layout className={classnames}>
        <Header>
          <NavBar
            collapsed={collapsedLeftSide}
            onCollapseLeftSide={this.onCollapseLeftSide}
            onExpandTopBar={this.onExpandTopBar}
            toggleSidebarHeader={this.toggleSidebarHeader}
            theme={theme.navbar}
            user={user}
            isMobile={isMobile}
            handleLogout={() => { this.props.dispatch({ type: "login/logout", payload: { key: new Date() } }); }}
          />
        </Header>
        <Layout>
          <LeftSideBar
            collapsed={collapsedLeftSide}
            leftCollapsedWidth={leftCollapsedWidth}
            showHeader={showSidebarHeader}
            onCollapse={this.onCollapseLeftSide}
            onCollapseAll={this.onCollapseLeftSideAll}
            location={location}
            theme={theme.leftSide}
            flatMenu={flatMenu}
            currentMenu={currentMenu}
            menu={menu}
            user={user}
            isMobile={isMobile}
          />
          <Content>
            {theme.layout.includes('tabLayout') ? (
              <TabsLayout childRoutes={childRoutes} location={location} initMenu={this._initMenu} />
            ) : (
                <Layout className="full-layout">
                  <Header>
                    <TopBar
                      expand={expandTopBar}
                      toggleRightSide={this.toggleRightSide}
                      collapsedRightSide={collapsedRightSide}
                      onCollapse={this.onCollapseTopBar}
                      currentMenu={currentMenu}
                      location={location}
                      theme={theme}
                    />
                  </Header>
                  <Content className="router-page">
                    <Switch>{childRoutes}</Switch>
                  </Content>
                </Layout>
              )}
          </Content>
          {/*<WizWatermarkCmp location={this.props.location}></WizWatermarkCmp>*/}
          {/* <WizWatermarkCmp location={this.props.location}></WizWatermarkCmp> */}
          {/* <RightSideBar
            collapsed={collapsedRightSide}
            isMobile={isMobile}
            onCollapse={this.toggleRightSide}
          /> */}
        </Layout>
        {/* <SkinToolbox onChangeTheme={this.onChangeTheme} theme={theme} /> */}
      </Layout>
    );
  }
}
